import { useTranslation } from 'react-i18next';
import type { RouteObject } from 'react-router';
import { PageHeader, useDocumentTitle } from '@/components/PageHeader';
import { WebhooksPanel } from './WebhooksPanel';
import { WorkItemPage } from './WorkItemPage';

/** `/settings/webhooks`: the platform's outgoing webhooks (e.g. the CRM). A customer's are on its page. */
export function WebhooksPage() {
  const { t } = useTranslation('work');
  useDocumentTitle(t('webhooks.title'));
  return (
    <>
      <PageHeader title={t('webhooks.title')} subtitle={t('webhooks.subtitle')} crumbs={[{ label: t('crumbs.settings') }]} />
      <WebhooksPanel owner="platform" />
    </>
  );
}

/** Detail routes (paths without a leading slash). */
export const WORK_ROUTES: RouteObject[] = [{ path: 'compliance/work/:id', element: <WorkItemPage /> }];

export { LinkedWork } from './LinkedWork';
export { WebhooksPanel } from './WebhooksPanel';
